import ProjectsLayout from "../../Views/Projects/Layout";
import Index from "../../Views/Projects/Index";
import Sort from "../../Views/Projects/Sort";
import AddForm from "../../Views/Projects/Form/Add";
import AddSubProjectForm from "../../Views/Projects/Form/AddSubProject";
import EditForm from "../../Views/Projects/Form/Edit";
import ProjectsDetailsLayout from "../../Views/Projects/Details/Layout";
import DetailsIndex from "../../Views/Projects/Details/Index";
import DetailsTasks from "../../Views/Projects/Details/Tasks";
import DetailsPlanning from "../../Views/Projects/Details/Planning";
import DetailsContacts from "../../Views/Projects/Details/Contacts";
import DetailsDocuments from "../../Views/Projects/Details/Documents";
import DetailsAddDocument from "../../Views/Projects/Details/AddDocument";
import DetailsHours from "../../Views/Projects/Details/Hours";
import DetailsHourTotals from "../../Views/Projects/Details/HourTotals";
import DetailsBudgets from "../../Views/Projects/Details/Budgets";
import DetailsInvoices from "../../Views/Projects/Details/Invoices";
import DetailsImages from "../../Views/Projects/Details/Images";

export default [
    {
        path:'/projects',
        component:ProjectsLayout,
        children:[
            {
                path:'',
                component:Index,
                name:'projects.index',
            },
            {
                path:'sort',
                component:Sort,
                name:'projects.sort.index',
            },
            {
                path:'add',
                component:AddForm,
                name:'projects.add',
            },
            {
                path:':uuid',
                component:ProjectsDetailsLayout,
                children:[
                    {
                        path:'edit',
                        component:EditForm,
                        name:'projects.details.edit',
                    },
                    {
                        path:'add',
                        component:AddSubProjectForm,
                        name:'projects.add.subproject',
                    },
                    {
                        path:'',
                        component:DetailsIndex,
                        name:'projects.details.index',
                    },
                    {
                        path:'tasks/:task_uuid?',
                        component:DetailsTasks,
                        name:'projects.details.tasks',
                    },
                    {
                        path:'planning',
                        component:DetailsPlanning,
                        name:'projects.details.planning',
                    },
                    {
                        path:'contacts',
                        component:DetailsContacts,
                        name:'projects.details.contacts',
                    },
                    {
                        path:'documents',
                        component:DetailsDocuments,
                        name:'projects.details.documents',
                    },
                    {
                        path:'documents/add',
                        component:DetailsAddDocument,
                        name:'projects.details.documents.add',
                    },
                    {
                        path:'hours',
                        component:DetailsHours,
                        name:'projects.details.hours',
                    },
                    {
                        path:'hours/totals',
                        component:DetailsHourTotals,
                        name:'projects.details.hourtotals',
                    },
                    {
                        path:'budgets',
                        component:DetailsBudgets,
                        name:'projects.details.budgets',
                    },
                    {
                        path:'invoices',
                        component:DetailsInvoices,
                        name:'projects.details.invoices',
                    },
                    {
                        path:'images',
                        component:DetailsImages,
                        name:'projects.details.images',
                    },
                ],
            }
        ]
    },
];
